<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav class="pull-left w-100" aria-label="Footer Navigation Bar">
        <ul>
          <li class="link">
            {{ text }}
          </li>
          <li class="f-right">
          </li>
        </ul>
      </nav>
    </div>
  </footer>
</template>

<script>
  import {TranslationsUtils} from '../../../utils/Translations'
  export default {
    mixins: [TranslationsUtils],
    data () {
      return {}
    },
    computed: {
      text () {
        return this.computeCaption(this.$store.state.configs.PATIENT_SUPPORT_INFO, this.$store.state.lang.value.toLowerCase())
      }
    }
  }

</script>
<style scoped>

.footer nav ul li {
    display: inline-block;
    padding: 0px 0px;
    margin: 17px 0px;
}
.footer nav {
    min-height: 75px;
}
.w-100{
  width: 100%;
}

.f-right{
  float: right;
}

.link{
  line-height: 2.9;
  float: left;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/ContentFooter.vue